export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h3 className="font-heading text-lg font-bold text-white mb-4">成全影院</h3>
              <p className="text-sm text-background-300 leading-relaxed">
                成全影院致力于为广大影迷提供免费电影在线观看服务，汇聚海量电影大全、电视剧全集和综艺大全资源。最新影片高清不卡顿免费看，让每一位观众都能享受流畅的观影体验。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '常见问答', href: '#faq' },
                  { label: '主题索引', href: '#index' },
                  { label: '最新更新', href: '#updates' },
                  { label: '投稿咨询', href: '#contact' },
                  { label: '热门话题', href: '#topics' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        const el = document.querySelector(item.href);
                        if (el) el.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-4">内容分类</h3>
              <ul className="space-y-2.5">
                {['动作大片', '喜剧剧场', '悬疑推理', '科幻巨制', '综艺娱乐', '动漫精选'].map((cat) => (
                  <li key={cat}>
                    <span className="text-sm text-background-300 whitespace-nowrap">{cat}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-4">合作伙伴</h3>
              <p className="text-sm text-background-300 leading-relaxed">
                更多优质合作伙伴持续加入中，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 成全影院. 本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-6">
              <span className="text-xs text-background-400 whitespace-nowrap">高清不卡顿 · 免费观看</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}